module.exports = __webpack_public_path__ + "img/dle_richworld1io.1dd1988.png";